"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unitedArabEmiratesTranslations = void 0;
var _types = require("../../../types");
const unitedArabEmiratesTranslations = exports.unitedArabEmiratesTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'نأسف جداً',
  [_types.ErrorPageTranslationKey.buttonText]: 'الرجوع',
  [_types.ErrorPageTranslationKey.text]: 'هذة الصفحة لا تعمل الأن',
  [_types.ErrorPageTranslationKey.notFound]: 'الصفحة التي تبحث عنها غير متوفرة',
  [_types.ErrorPageTranslationKey.unauthorized]: 'الصفحة التي تحاول الوصول إليها مقيدة ولم يتم تلبية جميع المعايير.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'برجاء التواصل مع فريق دعم Oriflame عبر البريد الإلكتروني:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'تم رفض عنوان URL المطلوب!'
};
